import ClientRenderedPageLoader from '../../../common/page/client-rendered-page-loader';


class ApplicationsPageLoader extends ClientRenderedPageLoader {

	requestPage(request) {
		const requestParams = this.prepareRequestParams(request);
		return this.api.execute('application/applications',	{}).then((response) => {
			if (response.isSuccess()) {
				const content = this.template.render(
					'page/application/applications',
					'applications',
					requestParams,
					['page', 'page--applications'],
					response.output.applications,
					response.output.form,
					response.output.appformDescriptions,
					response.output.introText
				);
				return {content: content, title: requestParams.title};
			}
			return false;
		}).catch((error) => {
			console.log('catching error', error);
			return false;
		});
	}


	prepareRequestParams(request) {
		const requestParams = {};
		for (const name in request.params) {
			if (request.params.hasOwnProperty(name) && request.params[name] !== undefined) {
				requestParams[name] = request.params[name];
			}
		}
		return requestParams;
	}

}


export default ApplicationsPageLoader;
